import React from 'react';

const TOOLS = [
  {
    id: 'intake',
    name: 'SEO Kick-Off Form',
    description: 'Walk new clients through the onboarding process — framework, access, NAP details and content survey. Generates a branded PDF document.',
    icon: '📋',
    color: '#1A2744',
    bg: '#F1F5F9',
    border: '#CBD5E1',
    status: 'live',
  },
  {
    id: 'keyword-research',
    name: 'Keyword Research',
    description: 'Research local SEO keywords, fetch search volumes and rankings, generate reports.',
    icon: '🔍',
    color: '#185FA5',
    bg: '#E6F1FB',
    border: '#85B7EB',
    status: 'live',
  },
  {
    id: 'meta-generator',
    name: 'Meta Data Generator',
    description: 'Generate optimised title tags and meta descriptions following IMSR best practices.',
    icon: '🏷️',
    color: '#27500A',
    bg: '#EAF3DE',
    border: '#97C459',
    status: 'live',
  },
  {
    id: 'content-brief',
    name: 'Content Brief & Writer',
    description: 'Create AIDA + E-A-T content briefs and generate full page copy without keyword research.',
    icon: '✍️',
    color: '#633806',
    bg: '#FAEEDA',
    border: '#FAC775',
    status: 'live',
  },
  {
    id: 'faq-creator',
    name: 'FAQ Creator',
    description: 'Find common questions people ask about a service and generate SEO-optimised answers.',
    icon: '❓',
    color: '#26215C',
    bg: '#EEEDFE',
    border: '#AFA9EC',
    status: 'live',
  },
,
  {
    id: 'report',
    name: 'Monthly SEO Report',
    description: 'Generate a professional branded PDF report with charts, actions completed and an AI executive summary.',
    icon: '📊',
    color: '#1A2744',
    bg: '#EFF6FF',
    border: '#BFDBFE',
    status: 'live',
  },
,
  {
    id: 'competitive',
    name: 'Competitive Analysis',
    description: 'Compare your client against top Google competitors — SERP rankings, on-page data, and backlink metrics side by side.',
    icon: '🔬',
    color: '#26215C',
    bg: '#EEEDFE',
    border: '#AFA9EC',
    status: 'live',
  },
  {
    id: 'volume-checker',
    name: 'Search Volume Checker',
    description: 'Enter services and a postcode radius to instantly check monthly search volumes for all service + location combinations.',
    icon: '📈',
    color: '#0F6E56',
    bg: '#E1F5EE',
    border: '#5DCAA5',
    status: 'live',
  },
];

export default function ToolLauncher({ onSelectTool }) {
  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <div className="page-title">IMSR SEO Toolkit</div>
        <div className="page-sub">Select a tool to get started</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {TOOLS.map(tool => (
          <div
            key={tool.id}
            onClick={() => tool.status === 'live' && onSelectTool(tool.id)}
            style={{
              background: '#fff',
              border: `1px solid ${tool.status === 'live' ? tool.border : 'var(--gray-200)'}`,
              borderRadius: 'var(--border-radius-lg, 12px)',
              padding: '1.5rem',
              cursor: tool.status === 'live' ? 'pointer' : 'default',
              transition: 'all 0.15s',
              opacity: tool.status === 'live' ? 1 : 0.6,
              position: 'relative',
              overflow: 'hidden',
            }}
            onMouseEnter={e => { if (tool.status === 'live') e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            {tool.status === 'coming-soon' && (
              <div style={{
                position: 'absolute', top: 12, right: 12,
                fontSize: 10, fontWeight: 700, padding: '3px 8px',
                borderRadius: 99, background: 'var(--gray-100)',
                color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: '0.05em'
              }}>
                Coming soon
              </div>
            )}
            <div style={{
              width: 48, height: 48, borderRadius: 12,
              background: tool.bg, display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              fontSize: 24, marginBottom: 16
            }}>
              {tool.icon}
            </div>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--gray-900)', marginBottom: 6 }}>
              {tool.name}
            </div>
            <div style={{ fontSize: 13, color: 'var(--gray-500)', lineHeight: 1.5 }}>
              {tool.description}
            </div>
            {tool.status === 'live' && (
              <div style={{ marginTop: 16, fontSize: 13, fontWeight: 500, color: tool.color }}>
                Open tool →
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
